/** Not a React Router path — Help Assistant is the sidebar / floating chat widget. */
export const HELP_ASSISTANT_ROUTE = "#help-assistant";

/**
 * Shared Help Assistant block for all role manuals.
 * @param {{ group?: string, supportTicketPath?: string }} options
 */
export function createHelpAssistantManualSection({
  group = "more",
  supportTicketPath = "/tickets",
} = {}) {
  return {
    id: "help-assistant",
    group,
    menuLabel: "Help Assistant (chat)",
    route: HELP_ASSISTANT_ROUTE,
    openPage: false,
    openAction: "helpAssistant",
    routeLabel: "Sidebar → Help · chat widget on any page",
    keywords: [
      "help",
      "assistant",
      "chatbot",
      "chat",
      "support",
      "ask",
      "ai",
      "bot",
      "guide",
      "how to",
    ],
    summary:
      "Built-in AI chat assistant available on every screen. Ask how to do anything in Chairside and it replies with step-by-step help and quick links, tailored to your role.",
    howToUse: [
      "Click **Help** in the sidebar or the teal chat button at the bottom-right of any page to open the assistant.",
      "Type your question in plain language (e.g. \"how do I generate SOAP notes\") and press Enter.",
      "Use suggested question chips, or click any link in an answer to jump to that screen.",
    ],
    faqs: [
      {
        question: "How do I open Help Assistant?",
        answer:
          "Click Help in the sidebar or the teal chat button at the bottom-right. It opens the chat panel — not a separate page like Dashboard.",
      },
      {
        question: "What can the Help Assistant answer?",
        answer: `Anything about using Chairside — features, workflows, and which role handles each task. If it can't help, open [[Support|${supportTicketPath}]].`,
      },
      {
        question: "Is the assistant available everywhere?",
        answer:
          "Yes — the chat widget is available on every screen while you are signed in.",
      },
    ],
  };
}
